import React, { useEffect, useState, useRef } from 'react';
import ChanterSvg from './ChanterSvg';

const ChanterFingeringAnimator = ({
  melodyNote,
  graceNote,
  melodyDuration = 500,
  graceDuration = 150,
  width = 120,
  height = 300,
  ...svgProps
}) => {
  const [showGrace, setShowGrace] = useState(false);
  const timerRef = useRef();

  useEffect(() => {
    if (melodyNote && graceNote) {
      setShowGrace(false); // Always start on melody
      // Start animation loop
      const loop = () => {
        setShowGrace(false);
        timerRef.current = setTimeout(() => {
          setShowGrace(true);
          timerRef.current = setTimeout(loop, graceDuration);
        }, melodyDuration);
      };
      loop();
      return () => clearTimeout(timerRef.current);
    } else {
      setShowGrace(false);
      if (timerRef.current) clearTimeout(timerRef.current);
    }
    return () => timerRef.current && clearTimeout(timerRef.current);
  }, [melodyNote, graceNote, melodyDuration, graceDuration]);

  if (!melodyNote && !graceNote) return null;

  if (melodyNote && graceNote && showGrace) {
    // Grace phase: show grace note fingering
    return (
      <ChanterSvg
        width={width}
        height={height}
        melodyNote={melodyNote}
        graceNote={graceNote}
        {...svgProps}
      />
    );
  } else if (melodyNote) {
    // Melody phase: show standard bagpipe fingering
    return (
      <ChanterSvg
        width={width}
        height={height}
        activeNote={melodyNote}
        {...svgProps}
      />
    );
  }
  return null;
};

export default ChanterFingeringAnimator; 